import cloneDeep from 'lodash/cloneDeep';

import type { SurveyAddonAlert } from '@webapp/common/resources/entities/survey-addons/alert';
import { initialSurveyAddonAlert } from '@webapp/common/resources/entities/survey-addons/alert';
import type { SurveyAddonBrand } from '@webapp/common/resources/entities/survey-addons/brand';
import { initialSurveyAddonBrand } from '@webapp/common/resources/entities/survey-addons/brand';
import type { SurveyAddonButtons } from '@webapp/common/resources/entities/survey-addons/buttons';
import { initialSurveyAddonButtons } from '@webapp/common/resources/entities/survey-addons/buttons';
import type { SurveyAddonFonts } from '@webapp/common/resources/entities/survey-addons/fonts';
import { initialSurveyAddonFonts } from '@webapp/common/resources/entities/survey-addons/fonts';
import type { SurveyAddonMain } from '@webapp/common/resources/entities/survey-addons/main';
import { initialSurveyAddonMain } from '@webapp/common/resources/entities/survey-addons/main';
import type { SurveyAddonParams } from '@webapp/common/resources/entities/survey-addons/params';
import { initialSurveyAddonParams } from '@webapp/common/resources/entities/survey-addons/params';
import type { SurveyAddonShare } from '@webapp/common/resources/entities/survey-addons/share';
import { initialSurveyAddonShare } from '@webapp/common/resources/entities/survey-addons/share';
import type { SurveyAddonTests } from '@webapp/common/resources/entities/survey-addons/tests';
import { initialSurveyAddonTests } from '@webapp/common/resources/entities/survey-addons/tests';
import type { SurveyAddonView } from '@webapp/common/resources/entities/survey-addons/view';
import { initialSurveyAddonView } from '@webapp/common/resources/entities/survey-addons/view';

export interface InfoParamsModel {
    alert: SurveyAddonAlert;
    main: SurveyAddonMain;
    other: SurveyAddonParams;
    tests: SurveyAddonTests;
    share: SurveyAddonShare;
}

export const initialInfoParams: Readonly<InfoParamsModel> = {
    alert: cloneDeep(initialSurveyAddonAlert),
    main: cloneDeep(initialSurveyAddonMain),
    other: cloneDeep(initialSurveyAddonParams),
    tests: cloneDeep(initialSurveyAddonTests),
    share: cloneDeep(initialSurveyAddonShare),
};

export interface ParamsCssModel {
    text: string | null;
}
/* .preProcessSnapshot((ss) => ({
    ...ss,
    // TODO fix backend core#282
    questionTextSize: parseInt(String(ss.questionTextSize), 10),
    replyTextSize: parseInt(String(ss.replyTextSize), 10),
    titleSize: parseInt(String(ss.titleSize), 10)
})) */
export interface InfoDesignModel {
    brand: SurveyAddonBrand;
    buttons: SurveyAddonButtons;
    css: ParamsCssModel;
    fonts: SurveyAddonFonts;
    view: SurveyAddonView;
}

export interface InfoDetailsModel {
    answer_bool: number | null;
    answer_group_id: number | null;
    answer_id: number | null;
    answer_int: number | null;
    answer_str: string | null;
    answer_text: string | null;
    comment: string | null;
    expired: string | null;
    file_id: number | null;
    question_id: number | null;
    cant_rate: number | null;
}

export interface InfoModel {
    id: number;
    title: string;
    complete: boolean;
    newToken: string | null;
    template: boolean;
    hideFooter: boolean;
    params: InfoParamsModel;
    design: InfoDesignModel;
    details?: Array<InfoDetailsModel>;
    shareLink?: string;
    savingNotComplete?: boolean;
    preservePhone?: string;
    authHash?: string;
    defaultLang?: string;
    multiLang?: boolean;
}

export const initialParamsCss: Readonly<ParamsCssModel> = {
    text: null,
};

export const initialInfoDesign: Readonly<InfoDesignModel> = {
    brand: cloneDeep(initialSurveyAddonBrand),
    buttons: cloneDeep(initialSurveyAddonButtons),
    css: cloneDeep(initialParamsCss),
    fonts: cloneDeep(initialSurveyAddonFonts),
    view: cloneDeep(initialSurveyAddonView),
};

export const initialInfo: Readonly<InfoModel> = {
    id: 0,
    title: '',
    complete: false,
    newToken: null,
    template: false,
    hideFooter: true,

    params: cloneDeep(initialInfoParams),
    design: cloneDeep(initialInfoDesign),
};
